import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AccordionModule } from 'primeng/accordion';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthInterceptor } from './appCommon/Interceptor/auth.interceptor';
import { AuthGuard } from './appCommon/AuthGuard/auth.guard';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';



@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
     AppRoutingModule,
      AccordionModule, 
      HttpClientModule,
      ToastModule,
      
      BrowserAnimationsModule,     
      BackButtonDisableModule.forRoot()
  ],
  providers: [MessageService,
    ConfirmationService,AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
